var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadingCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leading"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M6.36668 10.3436L12.1257 4.58462C12.2248 4.48547 12.3425 4.43483 12.4789 4.43268C12.6152 4.43055 12.7351 4.48119 12.8385 4.58462C12.9419 4.68803 12.9936 4.80683 12.9936 4.94102C12.9936 5.07519 12.9419 5.19399 12.8385 5.29742L6.78846 11.3474C6.66795 11.4679 6.52736 11.5282 6.36668 11.5282C6.206 11.5282 6.06541 11.4679 5.9449 11.3474L3.16156 8.56408C3.06242 8.46494 3.01349 8.3472 3.01476 8.21088C3.01605 8.07456 3.0684 7.95469 3.17181 7.85128C3.27524 7.74786 3.39404 7.69615 3.52821 7.69615C3.6624 7.69615 3.7812 7.74786 3.88461 7.85128L6.36668 10.3436Z",
    fill: "#74767C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadingCheck);
export default __webpack_public_path__ + "static/media/LeadingCheck.14881982d62f66195d21dea45c5df8d1.svg";
export { ForwardRef as ReactComponent };